import axios from 'axios'

const api = axios.create({
    baseURL: 'http://192.168.0.190:8000',
    // baseURL: 'http://localhost:8000',
});

export default api;